var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C9.43888 0 10.2 0.767512 10.2 1.71429V5.14286H13.6C14.5389 5.14286 15.3 5.91037 15.3 6.85714C15.3 7.80392 14.5389 8.57143 13.6 8.57143H10.2V12C10.2 12.9468 9.43888 13.7143 8.5 13.7143C7.56112 13.7143 6.8 12.9468 6.8 12V8.57143H3.4C2.46112 8.57143 1.7 7.80392 1.7 6.85714C1.7 5.91037 2.46112 5.14286 3.4 5.14286H6.8V1.71429C6.8 0.767512 7.56112 0 8.5 0ZM17 12C17 11.0532 17.7611 10.2857 18.7 10.2857H28.9C31.7167 10.2857 34 12.5882 34 15.4286V18.8571C34 21.6975 31.7167 24 28.9 24H5.1C2.28336 24 0 21.6975 0 18.8571V17.1429C0 16.1961 0.761116 15.4286 1.7 15.4286C2.63888 15.4286 3.4 16.1961 3.4 17.1429V18.8571C3.4 19.804 4.1611 20.5714 5.1 20.5714H28.9C29.8389 20.5714 30.6 19.804 30.6 18.8571V15.4286C30.6 14.4817 29.8389 13.7143 28.9 13.7143H18.7C17.7611 13.7143 17 12.9468 17 12Z",
    fill: "#263F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.9bc2d069e1e13e22c5a4f99f09d57f55.svg";
export { ForwardRef as ReactComponent };